import type { EstadoAlerta, EstadoDiarioUnidad, EstadoParada, EstadoUnidad, EstadoViaje, NivelAlerta } from '@tms/contratos';
import { ALERTA, DIARIO, NIVEL, PARADA, UNIDAD, VIAJE, type Presentacion } from './estados';

type Props =
  | { tipo: 'unidad'; valor: EstadoUnidad }
  | { tipo: 'viaje'; valor: EstadoViaje }
  | { tipo: 'parada'; valor: EstadoParada }
  | { tipo: 'alerta'; valor: EstadoAlerta }
  | { tipo: 'diario'; valor: EstadoDiarioUnidad }
  | { tipo: 'nivel'; valor: NivelAlerta };

export function presentacion(p: Props): Presentacion {
  switch (p.tipo) {
    case 'unidad':
      return UNIDAD[p.valor];
    case 'viaje':
      return VIAJE[p.valor];
    case 'parada':
      return PARADA[p.valor];
    case 'alerta':
      return ALERTA[p.valor];
    case 'diario':
      return DIARIO[p.valor];
    case 'nivel':
      return NIVEL[p.valor];
  }
}

/** Chip de estado: color con significado + ícono + texto (nunca solo color). */
export function ChipEstado(props: Props) {
  const { etiqueta, color, icono: Icono } = presentacion(props);
  return (
    <span className={`chip ${color}`}>
      <Icono aria-hidden />
      {etiqueta}
    </span>
  );
}

/** Variante sin borde, como la insignia de las tarjetas del diseño. */
export function Insignia(props: Props) {
  const { etiqueta, color, icono: Icono } = presentacion(props);
  return (
    <span className={`badge ${color === 'brand' ? 'green' : color}`}>
      <Icono aria-hidden />
      {etiqueta}
    </span>
  );
}
